import { from, HttpLink, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { stubFalse } from 'lodash'

import {
  createAuthLink,
  createRefreshTokenApolloErrorLink,
  createWebsocketLink,
} from '../helpers'

import FirebasePerformanceLink from './firebase-performance-link'

class ApolloRootLink {
  constructor({ httpUri, subscriptionUri }) {
    this.httpUri = httpUri
    this.subscriptionUri = subscriptionUri

    const webSocketLink = createWebsocketLink(this.subscriptionUri, stubFalse)

    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query)
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        )
      },
      webSocketLink,
      from([FirebasePerformanceLink, new HttpLink({ uri: httpUri })]),
    )

    this.link = splitLink
  }

  addAccessTokenToHeaders(getAccessToken, getNewAccessToken) {
    const authLink = createAuthLink(getAccessToken)

    const refreshTokenErrorLink =
      createRefreshTokenApolloErrorLink(getNewAccessToken)

    const webSocketLink = createWebsocketLink(
      this.subscriptionUri,
      getAccessToken,
    )

    const httpLink = from([
      refreshTokenErrorLink,
      authLink,
      FirebasePerformanceLink,
      new HttpLink({ uri: this.httpUri }),
    ])

    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query)
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        )
      },
      webSocketLink,
      httpLink,
    )

    this.link = splitLink
  }

  removeAccessTokenFromHeaders() {
    const webSocketLink = createWebsocketLink(this.subscriptionUri, stubFalse)

    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query)
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        )
      },
      webSocketLink,
      from([FirebasePerformanceLink, new HttpLink({ uri: this.httpUri })]),
    )

    this.link = splitLink
  }
}

export default ApolloRootLink
